import { 
  PROFILE_ERROR, 
  PROFILE_SUCCESS, 
  EDIT_PROFILE, 
  RESET_PROFILE_FLAG,
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAIL
} from "./actionTypes";

const initialState = {
  error: "",
  success: "",
  loading: false,
  userProfile: null,
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROFILE:
      state = { ...state, loading: true };
      break;
    case PROFILE_SUCCESS:
      state = { 
        ...state, 
        loading: false,
        success: action.payload,
        userProfile: action.payload.data || state.userProfile
      };
      break;
    case PROFILE_ERROR:
      state = { ...state, loading: false, error: action.payload };
      break;
    case RESET_PROFILE_FLAG:
      state = { ...state, success: null };
      break;
    case GET_PROFILE:
      state = { ...state, loading: true };
      break;
    case GET_PROFILE_SUCCESS:
      state = { 
        ...state, 
        loading: false,
        userProfile: action.payload
      };
      break;
    case GET_PROFILE_FAIL:
      state = { ...state, loading: false, error: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default profile;
